const flexibleCardsClass = ".flexible-cards";

function createFlexibleCards() {
  function init() {
    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll(flexibleCardsClass).forEach((flexibleCard) => {
        createSingleFlexibleCards(flexibleCard).init();
      });
    });
  }

  return { init };
}

function createSingleFlexibleCards(container) {
  let scrollContainer;
  let cards;

  function init() {
    scrollContainer = container.querySelector(
      `${flexibleCardsClass}__card-container`
    );
    cards = container.querySelectorAll(`${flexibleCardsClass}__item`);

    attachArrowListeners();
    initCardGradients();
  }

  function initCardGradients() {
    const firstCard = cards[0];
    const lastCard = cards[cards.length - 1];

    const cardsObserverConfig = {
      root: container,
      rootMargin: "0px",
      threshold: 1,
    };

    const cardsObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const isFirstCard = entry.target === cards[0];
        const cardContainerClass = isFirstCard ? "at-end" : "at-start";
        if (entry.isIntersecting) {
          container.classList.remove(cardContainerClass);
        } else {
          container.classList.add(cardContainerClass);
        }
      });
    }, cardsObserverConfig);
    cardsObserver.observe(firstCard);
    cardsObserver.observe(lastCard);
  }

  function attachArrowListeners() {
    const leftArrow = container.querySelector(
      `${flexibleCardsClass}__arrow--left`
    );
    const rightArrow = container.querySelector(
      `${flexibleCardsClass}__arrow--right`
    );
    if (!leftArrow || !rightArrow) return;

    leftArrow.addEventListener("click", () => {
      if (scrollContainer.scrollLeft <= 0) {
        scrollContainer.scrollTo({
          left: scrollContainer.scrollWidth,
          behavior: "smooth",
        });
      } else {
        scrollContainer.scrollBy({
          left: -container.offsetWidth,
          behavior: "smooth",
        });
      }
    });

    rightArrow.addEventListener("click", () => {
      if (
        scrollContainer.scrollLeft >=
        scrollContainer.scrollWidth - container.offsetWidth
      ) {
        scrollContainer.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        scrollContainer.scrollBy({
          left: container.offsetWidth,
          behavior: "smooth",
        });
      }
    });
  }

  return { init };
}

const flexibleCards = createFlexibleCards();
flexibleCards.init();
